// Form validation and submission logic
(function() {
    'use strict';
    
    // Only run if form exists on the page
    if (!document.getElementById('form')) return;
    
    document.addEventListener("DOMContentLoaded", function () {
        const submitBtn = document.getElementById("submitBtn");
        const form = document.getElementById("form");
        
        if (submitBtn) submitBtn.disabled = false;

        // Validation functions
        function validateName(name) {
            // Name should only contain letters, spaces, periods, apostrophes, hyphens - max 20 characters
            const nameRegex = /^[a-zA-Z\s\-'\.]{1,20}$/;
            return nameRegex.test(name) && name.trim().length > 0;
        }

        function validateZip(zip) {
            // ZIP code should be exactly 5 numbers
            const zipRegex = /^\d{5}$/;
            return zipRegex.test(zip);
        }

        function validateEmail(email) {
            // Email must contain @ symbol
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }

        function validatePhone(phone) {
            // Phone should be max 10 digits (only numbers)
            if (!phone || phone.trim() === '') return true; // Phone is optional
            const phoneRegex = /^\d{1,10}$/;
            return phoneRegex.test(phone);
        }

        function validateNPI(npi) {
            // NPI should be max 10 digits (only numbers)
            if (!npi || npi.trim() === '') return true; // NPI is optional
            const npiRegex = /^\d{1,10}$/;
            return npiRegex.test(npi);
        }

        function showError(fieldId, message) {
            const errorElement = document.getElementById(fieldId + '_error');
            let inputElement = document.getElementById(fieldId);
            
            // If no element found by ID, try to find by name (for radio buttons and checkboxes)
            if (!inputElement) {
                inputElement = document.querySelector(`input[name="${fieldId}"]`);
            }
            
            if (errorElement) {
                errorElement.textContent = message;
                errorElement.style.display = 'block';
            }
            if (inputElement) {
                // Special handling for radio buttons
                if (inputElement.type === 'radio') {
                    const radioGroup = document.querySelectorAll(`input[name="${fieldId}"]`);
                    radioGroup.forEach(radio => {
                        const customRadio = radio.nextElementSibling;
                        if (customRadio && customRadio.classList.contains('custom-radio')) {
                            customRadio.classList.add('error');
                        }
                    });
                }
                // Special handling for checkboxes with custom styling
                else if (inputElement.type === 'checkbox') {
                    const customCheckbox = inputElement.nextElementSibling;
                    if (customCheckbox && customCheckbox.classList.contains('custom-checkbox')) {
                        customCheckbox.classList.add('error');
                    }
                    inputElement.classList.add('error');
                } else {
                    inputElement.classList.add('error');
                }
            }
        }

        function clearError(fieldId) {
            const errorElement = document.getElementById(fieldId + '_error');
            let inputElement = document.getElementById(fieldId);
            
            // If no element found by ID, try to find by name (for radio buttons and checkboxes)
            if (!inputElement) {
                inputElement = document.querySelector(`input[name="${fieldId}"]`);
            }
            
            if (errorElement) {
                errorElement.textContent = '';
                errorElement.style.display = 'none';
            }
            if (inputElement) {
                // Special handling for radio buttons
                if (inputElement.type === 'radio') {
                    const radioGroup = document.querySelectorAll(`input[name="${fieldId}"]`);
                    radioGroup.forEach(radio => {
                        const customRadio = radio.nextElementSibling;
                        if (customRadio && customRadio.classList.contains('custom-radio')) {
                            customRadio.classList.remove('error');
                        }
                    });
                }
                // Special handling for checkboxes with custom styling
                else if (inputElement.type === 'checkbox') {
                    const customCheckbox = inputElement.nextElementSibling;
                    if (customCheckbox && customCheckbox.classList.contains('custom-checkbox')) {
                        customCheckbox.classList.remove('error');
                    }
                    inputElement.classList.remove('error');
                } else {
                    inputElement.classList.remove('error');
                }
            }
        }

        function validateForm() {
            let isValid = true;

            // Clear all previous errors
            const errorFields = ['first_name', 'last_name', 'email', 'zip', 'user_type', 'privacy_agree', 'consent_agree'];
            errorFields.forEach(field => clearError(field));

            // Validate first name
            const firstName = document.getElementById('first_name').value.trim();
            if (!firstName) {
                showError('first_name', 'This field is required.');
                isValid = false;
            } else if (!validateName(firstName)) {
                showError('first_name', 'First name must be maximum 20 characters and contain only letters, spaces, hyphens, apostrophes, and periods.');
                isValid = false;
            }

            // Validate last name
            const lastName = document.getElementById('last_name').value.trim();
            if (!lastName) {
                showError('last_name', 'This field is required.');
                isValid = false;
            } else if (!validateName(lastName)) {
                showError('last_name', 'Last name must be maximum 20 characters and contain only letters, spaces, hyphens, apostrophes, and periods.');
                isValid = false;
            }

            // Validate email
            const email = document.getElementById('email').value.trim();
            if (!email) {
                showError('email', 'This field is required.');
                isValid = false;
            } else if (!validateEmail(email)) {
                showError('email', 'Please enter a valid email address.');
                isValid = false;
            }

            // Validate ZIP code
            const zip = document.getElementById('zip').value.trim();
            if (!zip) {
                showError('zip', 'This field is required.');
                isValid = false;
            } else if (!validateZip(zip)) {
                showError('zip', 'ZIP code must be exactly 5 numbers.');
                isValid = false;
            }

            // Validate phone if field exists (optional field)
            const phoneField = document.getElementById('phone_number');
            if (phoneField) {
                const phone = phoneField.value.trim();
                if (phone && !validatePhone(phone)) {
                    showError('phone_number', 'Phone number must be maximum 10 digits.');
                    isValid = false;
                }
            }

            // Validate NPI if field exists (optional field)
            const npiField = document.getElementById('npi');
            if (npiField) {
                const npi = npiField.value.trim();
                if (npi && !validateNPI(npi)) {
                    showError('npi', 'NPI must be maximum 10 digits.');
                    isValid = false;
                }
            }

            // Validate user type (radio buttons)
            const userType = document.querySelector('input[name="user_type"]:checked');
            if (!userType) {
                showError('user_type', 'You must make a selection.');
                isValid = false;
            }

            // Validate privacy agreement
            const privacyAgree = document.querySelector('input[name="privacy_agree"]');
            if (!privacyAgree.checked) {
                showError('privacy_agree', 'You must certify that you are a US resident and 18 years or older to continue.');
                isValid = false;
            }

            // Validate consent agreement
            const consentAgree = document.querySelector('input[name="consent_agree"]');
            if (!consentAgree.checked) {
                showError('consent_agree', 'You must provide your consent to proceed.');
                isValid = false;
            }

            return isValid;
        }

        // Add real-time validation for specific fields
        document.getElementById('first_name').addEventListener('blur', function() {
            const value = this.value.trim();
            if (value && !validateName(value)) {
                showError('first_name', 'First name must be maximum 20 characters and contain only letters, spaces, hyphens, apostrophes, and periods.');
            } else {
                clearError('first_name');
            }
        });

        document.getElementById('last_name').addEventListener('blur', function() {
            const value = this.value.trim();
            if (value && !validateName(value)) {
                showError('last_name', 'Last name must be maximum 20 characters and contain only letters, spaces, hyphens, apostrophes, and periods.');
            } else {
                clearError('last_name');
            }
        });

        // Restrict first name input to letters, spaces, hyphens, apostrophes, periods and max 20 characters
        document.getElementById('first_name').addEventListener('input', function() {
            this.value = this.value.replace(/[^a-zA-Z\s\-'\.]/g, '').substring(0, 20);
        });

        // Restrict last name input to letters, spaces, hyphens, apostrophes, periods and max 20 characters
        document.getElementById('last_name').addEventListener('input', function() {
            this.value = this.value.replace(/[^a-zA-Z\s\-'\.]/g, '').substring(0, 20);
        });

        document.getElementById('zip').addEventListener('blur', function() {
            const value = this.value.trim();
            if (value && !validateZip(value)) {
                showError('zip', 'ZIP code must be exactly 5 numbers.');
            } else {
                clearError('zip');
            }
        });

        // Restrict ZIP code input to numbers only and max 5 digits
        document.getElementById('zip').addEventListener('input', function() {
            this.value = this.value.replace(/\D/g, '').substring(0, 5);
        });

        // Add phone field validation if it exists
        const phoneField = document.getElementById('phone_number');
        if (phoneField) {
            phoneField.addEventListener('blur', function() {
                const value = this.value.trim();
                if (value && !validatePhone(value)) {
                    showError('phone_number', 'Phone number must be maximum 10 digits.');
                } else {
                    clearError('phone_number');
                }
            });

            // Restrict phone input to numbers only and max 10 digits
            phoneField.addEventListener('input', function() {
                this.value = this.value.replace(/\D/g, '').substring(0, 10);
            });
        }

        // Add NPI field validation if it exists
        const npiField = document.getElementById('npi');
        if (npiField) {
            npiField.addEventListener('blur', function() {
                const value = this.value.trim();
                if (value && !validateNPI(value)) {
                    showError('npi', 'NPI must be maximum 10 digits.');
                } else {
                    clearError('npi');
                }
            });

            // Restrict NPI input to numbers only and max 10 digits
            npiField.addEventListener('input', function() {
                this.value = this.value.replace(/\D/g, '').substring(0, 10);
            });
        }

        // Clear errors when radio buttons are selected
        const radioButtons = document.querySelectorAll('input[name="user_type"]');
        radioButtons.forEach(radio => {
            radio.addEventListener('change', function() {
                clearError('user_type');
            });
        });

        // Function to show thank you message
        function showThankYouMessage() {
            const stayConnectedSection = document.getElementById('stay-connected');
            if (stayConnectedSection) {
                // Update the existing section content instead of replacing HTML
                const sectionHeader = stayConnectedSection.querySelector('.section-header h2');
                const sectionDescription = stayConnectedSection.querySelector('.section-header p');
                const formElement = stayConnectedSection.querySelector('.signup-form');
                
                if (sectionHeader) {
                    sectionHeader.textContent = "Thank you for registering";
                }
                
                if (sectionDescription) {
                    sectionDescription.textContent = "We will send you occasional email updates regarding achondroplasia.";
                }
                
                if (formElement) {
                    formElement.style.display = "none";
                }
                
                // Scroll to the thank you message with header offset
                setTimeout(() => {
                    const header = document.querySelector('header') || document.querySelector('.header');
                    const headerHeight = header ? header.offsetHeight : 80; // fallback to 80px if header not found
                    const elementPosition = stayConnectedSection.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - headerHeight - 20; // extra 20px padding
                    
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }, 100); // Small delay to ensure content is rendered
                
                // Trigger GTM event if available
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'form_submit_success', {
                        'event_category': 'engagement',
                        'event_label': 'sign-up'
                    });
                }
                
                // Clear any hash from URL
                if (window.location.hash) {
                    history.replaceState(null, null, window.location.pathname + window.location.search);
                }
            }
        }

        // Flag to prevent showing success message multiple times
        let successMessageShown = false;

        // Handle form submission with redirect approach
        function submitFormWithRedirect(token) {
            // Set reCAPTCHA token
            document.getElementById("recaptchaToken").value = token;
            
            // Disable submit button during submission
            submitBtn.disabled = true;
            submitBtn.classList.add('submitting');
            submitBtn.innerHTML = 'Submitting...';
            
            // Submit the form via fetch to handle the response
            const formData = new FormData(form);
            
            fetch(form.action, {
                method: form.method,
                body: formData
            })
            .then(response => {
                // Redirect to confirmation page regardless of response
                // The external service will handle the form submission
                window.location.href = '/confirmation/';
            })
            .catch(error => {
                console.error('Form submission error:', error);
                // Still redirect to confirmation page on error
                window.location.href = '/confirmation/';
            });
        }

        // Handle form submission
        submitBtn.addEventListener("click", function (e) {
            e.preventDefault();
            
            if (this.disabled) return;

            if (!form) return;

            // Validate form before submission
            if (!validateForm()) {
                return;
            }

            // If validation passes, proceed with reCAPTCHA
            grecaptcha.ready(function () {
                grecaptcha.execute("6Lf3aOQrAAAAAEMCQre0Z3dbqdEOClxSy9PKpGNV", { action: "submit" })
                    .then(function (token) {
                        submitFormWithRedirect(token);
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA execution failed:", error);
                        alert("CAPTCHA verification failed. Please try again.");
                    });
            });
        });
    });
})();
